<div class="otiMainWrapper">
  <div class="otiWrapper">
    <h3 class="pl-30">ORDER DETAIL</h3>
    <div class="topSection xs-pl-10 xs-pr-10 lg-pl-0 lg-pr-0">
      <div class="alignTopSec">
        <div class="row">
          <div class="col-md-12 padding-r0">
            <div class="row addressRow">
              <div class="col-md-3 padding-l0 col-12">
                <div class="row topMargin">
                  <div class="col-sm-8 col-7 text-title-mob">SALES ORDER #:</div>
                  <div class="col-sm-4 font-size-mob col-5 summaryValue font-size-mob">
                    <span>{{salesOrderNumber}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-8 col-7 text-title-mob">ORDER DATE:</div>
                  <div class="col-sm-4 font-size-mob col-5 summaryValue">
                    <span>{{headerDetails.orderDate | date:'MM/dd/yyyy'}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-8 col-7 text-title-mob">CUSTOMER PO#:</div>
                  <div class="col-sm-4 font-size-mob col-5 summaryValue">
                    <span>{{headerDetails.custPONumber}}</span>
                  </div>
                </div>
                <div class="row" *ngIf="!headerDetails.isOrderTakenByEmployee">
                  <div class="col-sm-8 col-7 text-title-mob">PLACED BY:</div>
                  <div class="col-sm-4 font-size-mob col-5 summaryValue">
                    <span>{{headerDetails.placedBy}}&nbsp;</span>
                  </div>
                </div>

              </div>
              <div class="col-md-3">
                <div class="row topMargin">
                  <div class="col-sm-8 col-7 text-title-mob">REQUESTED DELIVERY DATE:</div>
                  <div class="summaryValue font-size-mob col-5 col-sm-4">
                    <span>{{headerDetails.requestedDeliveryDate | date:'MM/dd/yyyy'}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-8">ORDER TYPE:</div>
                  <div class="col-sm-4 summaryValue">
                    <span>{{headerDetails.orderType}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-8">ORDER METHOD:</div>
                  <div class="col-sm-4 summaryValue">
                    <span>{{headerDetails.orderMethod}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-8 col-7 text-title-mob">ORDER STATUS:</div>
                  <div class="col-sm-4 font-size-mob col-5 summaryValue">
                    <span>{{headerDetails.orderStatus}}</span>
                  </div>
                </div>
              </div>

              <!--SoldTo Address-->
              <div *ngIf="headerDetails?.soldTo_Address" class="col-md-3">
                <div class="row">
                  <div class="col-sm-8 col-md-4 padding-r0 font-size-mob col-7 pad-left-45">SOLD TO: </div>
                  <div class="col-sm-4 col-md-8 padding-l0 summaryValue col-5 pad-left-8">

                    <p>{{headerDetails?.soldTo_Address?.soldToAccountNumber}} </p>
                    <p>{{headerDetails?.soldTo_Address?.soldToAccountName}} </p>
                    <p>{{headerDetails?.soldTo_Address?.soldToAddress1}} </p>
                    <p>{{headerDetails?.soldTo_Address?.soldToAddress2}} </p>
                    <p>{{headerDetails?.soldTo_Address?.soldToCity}} , {{headerDetails?.soldTo_Address?.soldToState}} {{headerDetails?.soldTo_Address?.soldToZipCode}} </p>
                  </div>
                </div>
              </div>

              <!--ShipTo & DeliverTo Address-->
              <div class="col-md-3">

                <!--ShipTo-->
                <div class="row">
                  <div class="col-sm-8 col-md-4 padding-r0 font-size-mob col-7 pad-left-45">SHIP TO: </div>
                  <div class="col-sm-4 col-md-8 padding-l0 summaryValue col-5 pad-left-8">
                    <p>{{headerDetails.staAccountNumber}} </p>
                    <p>
                      {{headerDetails.staAccountName}}
                    </p>
                    <p>{{headerDetails.staAddress}} </p>
                    <p>
                      {{headerDetails.staCity}} , {{headerDetails.staState}} {{headerDetails.staZipCode}}
                    </p>
                  </div>
                </div>

                <!--DeliverTo-->
              </div>
              <div class="col-md-3" *ngIf="headerDetails?.deliverTo_Address">
                <div class="row">
                  <div class="col-sm-8 col-md-4 padding-r0 font-size-mob col-7 pad-left-45">FULFILLMENT CENTER: </div>
                  <div *ngIf="headerDetails.deliverTo_Address; else elseBlock" class="col-sm-4 col-md-8 padding-l0 summaryValue col-5 pad-left-8">
                    <p>{{headerDetails?.deliverTo_Address?.deliverToAccountNumber}} </p>
                    <p>
                      {{headerDetails?.deliverTo_Address?.deliverToAccountName}}
                    </p>
                    <p>{{headerDetails?.deliverTo_Address?.deliverToAddress}} </p>
                    <p>
                      {{headerDetails?.deliverTo_Address?.deliverToCity}} , {{headerDetails?.deliverTo_Address?.deliverToState}} {{headerDetails?.deliverTo_Address?.deliverToZipCode}}
                    </p>
                  </div>
                </div>
                <!--<div class="row" *ngIf="headerDetails?.ship_From">
                  <div class="col-sm-8 col-md-4 padding-r0 font-size-mob col-7">SHIP FROM: </div>
                  <div class="col-sm-4 col-md-8 padding-l0 summaryValue col-5 pad-left-8">
                    <p>{{headerDetails?.ship_From?.sfAccount}} </p>
                    <p>
                      {{headerDetails?.ship_From?.sfCity}} , {{headerDetails?.ship_From?.sfState}}
                    </p>
                  </div>
                </div>-->
              </div>
              <!--<div class="col-md-3" *ngIf="headerDetails?.ship_From && !headerDetails?.deliverTo_Address">
                <div class="row">
                  <div class="col-sm-8 col-md-4 padding-r0 font-size-mob col-7">SHIP FROM: </div>
                  <div class="col-sm-4 col-md-8 padding-l0 summaryValue col-5 pad-left-8">
                    <p>{{headerDetails?.ship_From?.sfAccount}} </p>
                    <p>
                      {{headerDetails?.ship_From?.sfCity}} , {{headerDetails?.ship_From?.sfState}}
                    </p>
                  </div>
                </div>
              </div>-->
            </div>
          </div>
        </div>

        <div class="row margin-t10">
          <div class="padding-10 col-12 mob-center-text product-tools-outer">
            <div class="">
              <div class="product-tools-tab">
                <div class="text-right tab-bar">
                  <ul>
                    <li (click)="generatePdf()" class="font-size-viewReport">
                      <span class="ml-3"><i><img src="../../../../assets/icon/svg/print.svg" alt="Print" /></i></span>
                      &nbsp;
                      Print
                    </li>
                    <li (click)="generatePdf()" class="font-size-viewReport">
                      <span class="ml-3"> <i> <img src="../../../../assets/icon/svg/email.svg" alt="email" /> </i> </span>
                      &nbsp;
                      Email
                    </li>
                    <li (click)="generatePdf()" class="font-size-viewReport">
                      <span class="ml-3"><i> <img src="../../../../assets/icon/svg/download.svg" alt="email" /></i></span>
                      &nbsp;
                      Download
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottomSection xs-pl-10 xs-pr-10 lg-pl-0 lg-pr-0">
      <div class="row">
        <div class="col-md-12 productTableOuter productMargin py-0 px-4">
          <div *ngFor="let item of orderSplitDetails">
            <div class="row  margin-t10 margin-b10 tableHeaderInfo">
              <div class="col-2">
                <span class="topPadHead" *ngIf="item.bolId != 0">BOL#: {{(item.bolId == '-' ? '' : item.bolId)}}</span>
              </div>
              <div class="col-4">
                <div class="row">
                  <div class="col-4 "><span class="topPadHead">Status Tracker:</span></div>
                  <div class="col-8 ">
                    <div class="status-dropdown" (click)="toggleArrow(item)">
                      <span>
                        {{item.orderStatus}}
                      </span>
                      <span class="arrow-icon">
                        <i class="fas" [ngClass]="item.chevronFlag ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <span class="topPadHead">Terms: {{item.paymentTerm}}</span>
              </div>

              <div class="col-3">
                <span class="topPadHead" *ngIf="item.invoiceDate != null">Invoice Date: {{item.invoiceDate | date:'MM/dd/yyyy'}}</span>
              </div>

            </div>
            <div class="otiTableArea">

              <div class="otiTimeline" [ngClass]="item.chevronFlag ? 'hide' : ''">
                <ul class="xs-hide">
                  <li *ngFor="let lst of item.otiStatusList" [ngClass]="{currentState : lst.sequenceNo == item.sequenceNo , completedState : lst.sequenceNo < item.sequenceNo}">
                    {{lst.chevronStatus}}
                  </li>
                </ul>
              </div>
              <div class="otiTimeline-mob  d-md-none" [ngClass]="item.chevronFlag ? 'hide' : ''">
                <ul>
                  <li *ngFor="let lst of MobileStatusList" [ngClass]="{currentState : lst.sequenceNo == item.sequenceNo , completedState : lst.sequenceNo < item.sequenceNo}">
                    {{lst.chevronStatus}}
                  </li>
                </ul>
              </div>
              <div class="abcd">
                <div class="tableContainer otiSummaryTable botMargin">
                  <table mat-table [dataSource]="item.productDetail" multiTemplateDataRows class="matTables productTable otiTable">
                    <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                      <div *ngIf="column=='product'"><th mat-header-cell *matHeaderCellDef class="prodNameBlock">Product</th>
                </div>
                <div *ngIf="column=='detail'"><th mat-header-cell *matHeaderCellDef class="viewProdDetails">&nbsp;</th></div>
                <div *ngIf="column=='quantity'"><th mat-header-cell *matHeaderCellDef class="orderedQuant text-center">Ordered Quantity</th></div>
                <div *ngIf="column=='orderUOM'"><th mat-header-cell *matHeaderCellDef class="orderedUOM  text-center">Order UOM</th></div>
                <div *ngIf="column=='packageSize'"><th mat-header-cell *matHeaderCellDef class="packSize text-center">Package Size</th></div>
                <div *ngIf="column=='tracking'"><th mat-header-cell *matHeaderCellDef class="packSize text-center">Tracking</th></div>

                <td mat-cell *matCellDef="let element">
                  <div *ngIf="column=='product'">
                    <div class="order-info defaultCursor margin-l0">
                      <p>
                        <span *ngIf="element.vendorName && element.vendorName =='Y'">WinField</span>
                        <span *ngIf="element.vendorName && element.vendorName !='Y'">{{element.vendorName}}</span>
                      </p>
                      <p class="grower-name">{{element.productName}}</p>
                    </div>
                  </div>
                  <div *ngIf="column=='detail'" class="viewProdDetailsData">
                    <ng-container>
                      <a (click)="showProductDetails(element);">{{element.isDetailDisplayed ? 'Hide Product Details':'View Product Details' }}</a>
                    </ng-container>
                    <ng-template #elseBlock>
                      <ng-container class="text-center productDetailsFont">View Product Details</ng-container>
                    </ng-template>
                  </div>
                  <div *ngIf="column=='quantity'" class="text-center largeTableTxt">
                    <ng-container> {{element.orderedQuantity | number:'1.4-4'}}</ng-container>
                  </div>
                  <div *ngIf="column=='orderUOM'" class="text-center largeTableTxt">{{element.orderUOM}}</div>
                  <div *ngIf="column=='packageSize'" class="text-center largeTableTxt">{{element.packageSize}}</div>
                  <div *ngIf="column=='tracking'" class="text-center"> <a *ngIf="item.shipmentTrackingForKitesURL" href="{{item.shipmentTrackingForKitesURL}}" target="_blank"><span class="truckImg icon-truck"></span></a></div>

                </td>
                </ng-container>

                <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                <ng-container matColumnDef="expandedDetail">
                  <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                    <div [style.display]="element.isDetailDisplayed ? 'block' : 'none'">
                      <div class="oti-prod-info mobile-nested-table">
                        <table style="width:100%">
                          <tbody>
                            <tr class="xs-hide">
                              <th width="10%" class="text-left">Item # </th>
                              <th width="10%"> GTIN </th>
                              <th width="15%"> Product Line </th>
                              <th width="25%"> Active Ingredients </th>
                              <th width="10%"> Unit  Price </th>
                              <th width="11%"> Pallet Quantity </th>
                              <th width="10%"> Restricted Use </th>
                              <th width="6%"> Non-Returnable </th>
                            </tr>
                            <tr>
                              <th width="10%" class="d-block d-sm-block d-md-none">Item # </th>

                              <td width="10%" class="text-left"><p>{{element.itemNumber}}</p> </td>
                              <th width="10%" class="d-block d-sm-block d-md-none"> GTIN </th>
                              <td width="10%"><p>{{element.gtin}}</p></td>
                              <th width="15%" class="d-block d-sm-block d-md-none"> Product Line </th>

                              <td width="15%"><p>{{element.productLine}}</p> </td>
                              <th width="25%" class="d-block d-sm-block d-md-none"> Active Ingredients </th>
                              <td width="25%"><p>{{element.activeIngredient}}</p> </td>
                              <th width="10%" class="d-block d-sm-block d-md-none"> National Price </th>

                              <td width="10%"><p *ngIf="plAccess">{{element.unitPrice | number:'1.4-4'}} / {{element.pricingUOM }}</p> </td>
                              <th width="11%" class="d-block d-sm-block d-md-none"> Pallet Quantity </th>
                              <td width="11%"><p>{{element.palletQuantity | number:'1.4-4'}}</p> </td>
                              <th width="10%" class="d-block d-sm-block d-md-none"> Restricted Use </th>

                              <td width="10%"><p>{{element.restrictedUse}}</p> </td>
                              <th width="6%" class="d-block d-sm-block d-md-none"> Non-Returnable </th>
                              <td width="6%"><div [ngClass]="{'oval-shape returnable':( element.returnable ==='X')}"><p>{{element.returnable}}</p></div></td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="terms">
                          *Price listed is subject to change based on price at time of shipment.
                        </div>
                      </div>
                    </div>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
                <tr mat-row *matRowDef="let element; columns: displayedColumns;"
                    class="example-element-row"
                    [class.example-expanded-row]="expandedElement === element"
                    (click)="expandedElement = expandedElement === element ? null : element"></tr>
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                </table>
                <div *ngIf="item.productDetail == undefined || item.productDetail?.length == 0" class="noDataMsg">
                  <p>No Record Found.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
        </div>
      </div>

      <div class="otiPageFooter">
        <div class="row">
          <div class="col-md-12">
            <button *ngIf="!isBackToCppOrderSummaryRequired" mat-raised-button class="btns xs-button xs-full-width" (click)="backToOTILandingPage()">Back To View Orders</button>
            <button *ngIf="isBackToCppOrderSummaryRequired" mat-raised-button class="btns xs-button xs-full-width" (click)="backToCPPSummaryPage()">Back To CPP Orders</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
